import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { BrandsAndDelegations, SelectWithLabel, Button, ButtonTag, ConversationTemplateEditor } from 'components/Form'
import InputChipsWithSearch from 'components/common/InputChipsWithSearch'
import { CustomInput } from 'reactstrap'
import ModalWrapper from 'components/ModalWrapper'
import { getStaticImage } from 'utils/statics'
import PhoneViewer from 'components/PhoneViewer'
import TextInputField from 'components/Form/TextInputField'
import TextEditor2 from 'components/Form/TextEditor/TextEditor2'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { lang } from 'utils/helpers'
import ModalVirusAttachments from 'components/common/ModalVirusAttachments'

const OutboundModalUI = ({
  outboundIndex,
  title,
  draftId,
  isMinimize,
  isMaximize,
  channels,
  inputButtons,
  users,
  company,
  configOutbound,
  setConfigOutbound,
  setHeaderInput,
  parsedTemplates,
  isOpenInfoModal,
  infoModal,
  toggleInfoModal,
  isOpenPreviewModal,
  togglePreviewModal,
  previewMessage,
  setPreviewMessage,
  handleContacts,
  handleClose,
  handleCloseChatmailField,
  handleMinimize,
  handleMaximize,
  handleSend,
  routeHistory,
  send,
  resetConfigOutbound,
  cleanEditor,
  setCleanEditor,
  disclaimerMessage,
  calcHeight,
  isLoadingMeetLink,
  handleClickToCall,
  replaceTemplateVariables
}) => (
  <>
    <div
      className={`outbound-modal ${isMaximize ? 'outbound-modal--maximized' : ''}`}
      style={{
        width: isMinimize
          ? '300px'
          : null,
      }}
    >
      <div className='outbound-modal__header'>
        <p className='outbound-modal__title text-ellipsis'>{title}</p>
        <div className='outbound-modal__window-controls'>
          <button onClick={handleMinimize}>
            <figure style={{ alignItems: isMinimize ? 'flex-start' : 'flex-end' }}>
              <img src={getStaticImage('/icons/orange-brand/icon-min.svg')} alt='Minimize'/>
            </figure>
          </button>
          <button onClick={handleMaximize}>
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-max.svg')} alt='Maximize'/>
            </figure>
          </button>
          <button onClick={handleClose}>
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-close-2.svg')} alt='Close'/>
            </figure>
          </button>
        </div>
      </div>
      {!isMinimize && (
        <>
          <div className='outbound-modal__body'>
            <div className='outbound-modal__conversation-config'>
              <div className='outbound-modal__config-container'>
                <strong>{I18n.t('dashboard_channel')}</strong>
                <div className='outbound-modal__channels'>
                  {channels.map(channel => {
                    if (channel && channel.name && channel.name !== '') {
                      return (
                        <span
                          key={channel.name.toLowerCase()}
                          style={{
                            color: configOutbound.channel === channel.name.toLowerCase()
                              ? '#ffffff'
                              : '#333333',
                            backgroundColor: !channel.isEnable
                              ? '#e6e6e6'
                              : configOutbound.channel === channel.name.toLowerCase()
                                ? '#333333'
                                : '#ffffff',
                            cursor: channel.isEnable ? 'pointer' : 'initial'
                          }}
                          onClick={() => {
                            if (channel.isEnable) {
                              setConfigOutbound(prevState => ({ ...prevState, channel: channel.name.toLowerCase(), provider: channel.provider, }))
                              resetConfigOutbound()
                            }
                          }}
                        >
                          {channel.name}
                        </span>
                      )
                    }
                    return null
                  })}
                </div>
              </div>
              <div className='outbound-modal__config-container'>
                <strong>{I18n.t('dashboard_from')}</strong>
                <div className='outbound-modal__from'>
                  {configOutbound.deliveryChannelOptions === null || configOutbound.deliveryChannelOptions.length ? (
                    <SelectWithLabel
                      label={lang('outbound-modal-delivery-channel')}
                      placeholder={`${lang('dashboard_select')}...`}
                      options={configOutbound.deliveryChannelOptions || []}
                      onChange={data => setConfigOutbound(prevState => ({
                        ...prevState,
                        provider: data.provider,
                        deliveryChannel: {
                          channel: {
                            value: data.value,
                            label: data.label,
                            name: data.channel,
                            provider: data.provider,
                            brand: data.brand,
                            delegation: data.delegation
                          },
                          assignToMe: data.assignToMe,
                          isBlockedAssignToMe: data.isBlockedAssignToMe
                        }
                      }))}
                      value={configOutbound.deliveryChannel.channel}
                      required
                    />
                  ) : (
                    <ButtonTag
                      icon={<img src={getStaticImage('/icons/orange-brand/external-link-primary.svg')} alt='External link' />}
                      value={`${lang('dashboard_configure')} ${lang(`channels_${configOutbound.channel}`)}`}
                      onClick={() => routeHistory.push(`/dashboard/configurations/channels?c=${configOutbound.channel}`)}
                      className={`button-tag-${configOutbound.channel}`}
                    />
                  )}
                  <BrandsAndDelegations
                    labelInside
                    currentBrands={configOutbound.brand}
                    onChangeBrands={brandsValue => setConfigOutbound(prevState => ({ ...prevState, brand: [brandsValue] }))}
                    currentDelegations={configOutbound.delegation}
                    onChangeDelegations={delegationsValue => setConfigOutbound(prevState => ({ ...prevState, delegation: [delegationsValue] }))}
                    placeholderBrands={`${lang('dashboard_select')}...`}
                    placeholderDelegations={`${lang('dashboard_select')}...`}
                    optionsWithoutAll={true}
                    withLabel={false}
                    multi={false}
                    required
                  />
                  <div className='outbound-modal__assign-me'>
                    <CustomInput
                      id={`assignment-${outboundIndex}`}
                      type='switch'
                      checked={configOutbound.deliveryChannel.assignToMe}
                      onChange={() => setConfigOutbound(prevState => ({
                        ...prevState,
                        deliveryChannel: {
                          ...prevState.deliveryChannel,
                          assignToMe: !configOutbound.deliveryChannel.assignToMe
                        }
                      }))}
                      disabled={configOutbound.deliveryChannel.isBlockedAssignToMe}
                    />
                    <span>{I18n.t('outbound-modal-assign-to-me')}</span>
                  </div>
                </div>
              </div>
              {configOutbound.visibleFields.some(field => field === 'to') && (
                <div className='outbound-modal__config-container'>
                  <strong>{`${I18n.t('chatmail_to')}*`}</strong>
                  <InputChipsWithSearch
                    values={configOutbound.to}
                    regex={configOutbound.channel === 'chatmail'
                      ? /^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/g  // RegEx: Email
                      : /^\+?\d+$/  // RegEx: Phone
                    }
                    buttons={configOutbound.channel === 'chatmail' && inputButtons}
                    hiddenButtons={configOutbound.channel === 'chatmail' && configOutbound.visibleFields}
                    data={users.to}
                    placeholder={configOutbound.channel === 'chatmail'
                      ? I18n.t('outbound-modal-email-receiver')
                      : I18n.t('outbound-modal-phone-receiver')
                    }
                    onChange={values => {
                      handleContacts({ type: 'to', values })
                      setHeaderInput({ type: 'to', value: values.input })
                    }}
                  />
                </div>
              )}
              {configOutbound.visibleFields.some(field => field === 'cc') && (
                <div className='outbound-modal__config-container'>
                  <strong>Cc</strong>
                  <div className='outbound-modal__input-chips-container'>
                    <InputChipsWithSearch
                      values={configOutbound.cc}
                      regex={/^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/g}  // RegEx: Email
                      data={users.cc}
                      onChange={values => {
                        handleContacts({ type: 'cc', values })
                        setHeaderInput({ type: 'cc', value: values.input })
                      }}
                    />
                    <button type='button' className='outbound-modal__btn-close' onClick={() => handleCloseChatmailField({ field: 'cc' })}>
                      <i className="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              )}
              {configOutbound.visibleFields.some(field => field === 'cco') && (
                <div className='outbound-modal__config-container'>
                  <strong>Cco</strong>
                  <div className='outbound-modal__input-chips-container'>
                    <InputChipsWithSearch
                      values={configOutbound.cco}
                      regex={/^((?!\.)[\w-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/g}  // RegEx: Email
                      data={users.cco}
                      onChange={values => {
                        handleContacts({ type: 'cco', values })
                        setHeaderInput({ type: 'cco', value: values.input })
                      }}
                    />
                    <button type='button' className='outbound-modal__btn-close' onClick={() => handleCloseChatmailField({ field: 'cco' })}>
                      <i className="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              )}
              {configOutbound.channel === 'chatmail' && (
                <div className='outbound-modal__config-container'>
                  <strong>{`${I18n.t('outbound-modal-subject')}*`}</strong>
                  <input
                    className='outbound-modal__subject'
                    type='text'
                    value={configOutbound.subject || ''}
                    onChange={event => setConfigOutbound({ ...configOutbound, subject: event.target.value })}
                  />
                </div>
              )}
            </div>
            <div
              className={`outbound-modal__conversation-content outbound-modal__conversation-content--files-preview`}
              style={{ height: isMaximize ? '100%' : '440px', maxHeight: isMaximize ? '100%' : '500px' }}
            >
              {disclaimerMessage ? (
                <div className='outbound-modal__disclaimer'>
                  <figure>
                    <img src={getStaticImage('/icons/orange-brand/icon-warning.svg')} alt='Disclaimer' />
                  </figure>
                  {disclaimerMessage}
                </div>
              ) : null}
              {configOutbound.channel !== 'whatsapp' ? (
                <div className='outbound-modal__templates-config'>
                  <SelectWithLabel
                    isClearable
                    classNameWrapper='outbound-modal__chatmail-template-selector'
                    placeholder={I18n.t('outbound-modal-template-selector')}
                    value={configOutbound.template}
                    options={parsedTemplates[configOutbound.channel]?.parsed}
                    onChange={template => {
                      if (template) {
                        const _message = parsedTemplates[configOutbound.channel]?.original?.find(it => it._id === template.value)
                        setConfigOutbound(prevState => ({
                          ...prevState,
                          template,
                          subject: _message.subject || '',
                          message: _message,
                          variables: _message.variables
                        }))
                      } else {
                        setConfigOutbound(prevState => ({
                          ...prevState,
                          template: null,
                          subject: '',
                          message: {},
                          variables: []
                        }))
                        setCleanEditor(prevState => prevState + 1)
                      }
                    }}
                  />
                  <ButtonTag
                    icon={<img src={getStaticImage('/icons/orange-brand/external-link-primary.svg')} alt='External link' />}
                    value={I18n.t('dashboard_create-modify-templates-in-section')}
                    onClick={() => routeHistory.push(`/dashboard/marketing/templates?formTemplate=${configOutbound.channel}`)}
                  />
                </div>
              ) : null}
              {configOutbound.channel !== 'whatsapp' ? (
                <TextEditor2
                  key={`key-${configOutbound.channel}`}
                  company={company}
                  channel={configOutbound.channel}
                  limit={0}
                  rows={10}
                  value={configOutbound.message?.contentHtml || configOutbound.message?.content || ''}
                  newValue={configOutbound.message?.contentHtml || configOutbound.message?.content || ''}
                  attachments={configOutbound.message?.attachments}
                  buttons={configOutbound.message?.buttons}
                  options={['preview', 'buttons', 'emojis', 'attachments']}
                  onChange={data => {
                    setPreviewMessage({
                      content: data.value,
                      contentHtml: data.valueHtml,
                      buttons: data.buttons || [],
                      attachments: data.attachments || []
                    })
                  }}
                  dropZoneFilesHeight={359}
                  onPreviewMsg={togglePreviewModal}
                  classNameWrapper={`text-editor-wrapper-${configOutbound.channel}`}
                  forceCleaning={cleanEditor}
                  minHeight={isMaximize ? calcHeight(isMaximize) : 290}
                  maxHeight={isMaximize ? calcHeight(isMaximize) : 290}
                  filesPreview
                  isTemplateValue
                  isSmall
                />
              ) : configOutbound.deliveryChannel.channel ? (
                <ConversationTemplateEditor
                  className='outbound-modal__template-composer'
                  channel={configOutbound.deliveryChannel.channel.name}
                  provider={configOutbound.deliveryChannel.channel.provider}
                  channelId={configOutbound.deliveryChannel.channel.value}
                  templateId={configOutbound.template?.value}
                  text={replaceTemplateVariables(configOutbound.message?.content)}
                  onChangeTemplate={template => {
                    setConfigOutbound(prevState => ({
                      ...prevState,
                      template: {
                        label: template?.name || '',
                        value: template?._id || ''
                      },
                      message: {
                        content: template?.content || '',
                        contentHtml: template?.contentHtml || '',
                        attachments: template?.attachments || [],
                        buttons: template?.buttons || []
                      },
                      variables: template?.variables || []
                    }))
                  }}
                  onChangeVariables={variables => {
                    setConfigOutbound(prevState => ({ ...prevState, variables }))
                  }}
                  onChangeFiles={(files => {
                    setConfigOutbound(prevState => ({
                      ...prevState,
                      message: {
                        ...prevState.message,
                        attachments: files
                      }
                    }))
                  })}
                />
              ) : (
                <p className='message'>{lang('dashboard_outbound_select-channel-to-template')}</p>
              )}
            </div>
            {(configOutbound.channel !== 'whatsapp' && (configOutbound?.variables || []).length) ? (
              <div className='outbound-modal__variables'>
                <label>{I18n.t('dashboard_variables')}</label>
                <ul className='variables'>
                  {(configOutbound?.variables || []).map((it, index) => (
                    <li key={index}>
                      <div className='variable-item'>
                        <div className='code-wrapper'>
                          <code>{`${it.name}`}</code>:
                        </div>
                        {it.field === '' ? (
                          <>
                            <TextInputField
                              value={it.value || ''}
                              placeholder={I18n.t('dashboard_free-text')}
                              className={'variable-input'}
                              onChange={(value) => {
                                const _var = configOutbound.variables.map( it2 => it2.name === it.name ? { ...it2, value: value } : it2)
                                setConfigOutbound(prevState => ({
                                  ...prevState,
                                  variables: _var
                                }))
                              }}
                            />
                            <strong>{` *`}</strong>
                          </>
                        ) : (
                          <TextInputField
                            value={I18n.t(configOutbound.templateVariables.find(v => v.value === it.field)?.label || it.field)}
                            disabled={true}
                            className={'variable-input'}
                          />
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
            {send.error && <p className='message message--error'>{I18n.t(`outbound-modal-error-${send.error}`)}</p>}
          </div>
          <div className='outbound-modal__footer'>
            <Button
              secondary
              value={I18n.t('dashboard_send')}
              onClick={() => handleSend({ deliveryType: 'message', draftId })}
              isSubmitting={send.isSending}
            />
            <Button
              bordered
              value={I18n.t('dashboard_draft')}
              onClick={() => handleSend({ deliveryType: 'draft', draftId })}
              isSubmitting={send.isSendingDraft}
            />

            {configOutbound.channel !== 'whatsapp' ? (
              <button
                className='outbound-modal__icon-btn'
                title={I18n.t('dashboard_create-videocall-link')}
                onClick={handleClickToCall}
              >
                {!isLoadingMeetLink ? (
                  <figure>
                    <img
                      src={getStaticImage('/icons/orange-brand/icon-videocall-primary.svg')}
                      alt={I18n.t('dashboard_videocall')}
                    />
                  </figure>
                ) : (
                  <Nixi1Spinner width='17px' height='17px' />
                )}
              </button>
            ) : null}
          </div>
        </>
      )}
    </div>
    <ModalWrapper
      isOpen={isOpenInfoModal}
      toggle={() => toggleInfoModal({})}
      header={' '}
      eventBtnTxt={I18n.t(infoModal.btnTxt || '')}
      eventBtn={() => {
        routeHistory.push(infoModal.route)
        handleMinimize()
        toggleInfoModal({})
      }}
      cancelBtnTxt={I18n.t('dashboard_cancel')}
      cancelBtn={() => toggleInfoModal({})}
      body={
        <div className='modal-content'>
          <p dangerouslySetInnerHTML={{
            __html: I18n.t(infoModal.text || '')
          }}></p>
        </div>
      }
      contentClassName='outbound-modal'
    />
    <ModalWrapper
      isOpen={isOpenPreviewModal}
      toggle={togglePreviewModal}
      header={I18n.t('dashboard_preview')}
      body={
        <div className='modal-content'>
          <PhoneViewer
            textPreview={previewMessage}
            channel={configOutbound.channel}
            previewMsg
          />
        </div>
      }
      eventBtnTxt={I18n.t('dashboard_close')}
      eventBtn={togglePreviewModal}
      contentClassName='modal-content-phone-preview'
    />
    {
      previewMessage && previewMessage.attachments && previewMessage?.attachments.length
        ? <ModalVirusAttachments attachments={previewMessage?.attachments || []} />
        : null
    }
  </>
)

export default OutboundModalUI
